// extracted by mini-css-extract-plugin
module.exports = {"mzwsl9m":"mzwsl9m","scefed4":"scefed4"};